import React from "react";
import styled from "styled-components";

const RadioGroupContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	justify-content: center;
	align-items: baseline;
	padding: 6px 12px;
`;

const RadioButtonLabel = styled.label`
	display: flex;
	gap: 16px;
	width: 100%;
	cursor: pointer;

	input {
		position: relative;
		appearance: none;
		width: 20px;
		height: 20px;
		border: 2px solid var(--color-surface-variant);
		border-radius: 50%;
		cursor: pointer;
		transition: 0.3s;
	}

	input::after {
		position: absolute;
		content: "";
		top: calc(50% - 5px);
		left: calc(50% - 5px);
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background: transparent;
		transition: 0.3s;
	}

	input:hover::after {
		background: var(--color-surface-variant);
	}

	input:checked {
		border-color: var(--color-primary);
	}

	input:checked::after {
		background: var(--color-primary);
	}
`;

class RadioGroup extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			checkedValue: this.props.defaultCheck,
		};

		this.radioRefs = {};
	}

	handleChange = (value) => {
		this.setState({
			checkedValue: value,
		});
	};

	setCheckedValue = (value) => {
		this.setState({
			checkedValue: value,
		});
	};

	getCheckedValue = () => {
		return this.state.checkedValue;
	};

	render() {
		return (
			<RadioGroupContainer>
				{React.Children.map(this.props.children, (child) =>
					React.cloneElement(child, {
						name: this.props.name,
						checked: this.state.checkedValue === child.props.value,
						onChange: this.handleChange,
						ref: (ref) => (this.radioRefs[child.props.value] = ref),
					})
				)}
			</RadioGroupContainer>
		);
	}
}

class RadioButton extends React.Component {
	render() {
		return (
			<RadioButtonLabel>
				<input
					type="radio"
					name={this.props.name}
					value={this.props.value}
					checked={this.props.checked}
					onChange={() => this.props.onChange(this.props.value)}
				/>
				{this.props.label}
			</RadioButtonLabel>
		);
	}
}

export { RadioGroup, RadioButton };
